import { type Component, type Ref } from 'vue';
import { AppEnums } from '../../shared/enums';
import { AppCoreEnums } from '../shared/enums';
import { RouteParams, RouteMeta, RouteRecordNormalized } from 'vue-router';
import { IFilterItem, IPagedList, ISideMenuItem, Pagination } from '@/stores/core/models';
import { IDynamicFilterItem, IFormToolbarOptions } from '@/stores/core/models';

export class ResolveParams {
  constructor() {
    this.params = {};
    this.useStoreData = false;
    this.initialDynamicFilters = [];
    this.initialFiltersFromUserPreferences = [];
  }
  pagination: Pagination | undefined;
  routeParams: RouteParams | undefined;

  params: Partial<Record<'id' | 'id2' | 'id3', string>>;
  routeName: string = '';

  initialFiltersFromUserPreferences: IFilterItem[];
  initialDynamicFilters: IDynamicFilterItem[];

  useStoreData: boolean;
  containerType: AppCoreEnums.ContainerType = AppCoreEnums.ContainerType.NotSpecifiedContainer;
}

export interface IRouteMetaPermissions {
  readPermission?: string | undefined;
  writePermission?: string | undefined;
  deletePermission?: string | undefined;
}

export interface IRouteMeta extends RouteMeta {
  formComponent?: () => Promise<Component>;
  formToolbarComponent?: () => Promise<Component>;
  formToolbarOptions?: IFormToolbarOptions;
  formModel?: () => Ref<any>;
  formSave?: () => (model: any) => Promise<any>;
  formDelete?: (id: any) => Promise<any>;
  collapsibleTableTitleField?: string;
  translateCollapsibleTableTitleField?: boolean;
  formNewTitle?: string;
  mustTranslateFormTitle?: boolean;
  containerType: AppCoreEnums.ContainerType;
  innerContainerType?: AppCoreEnums.ContainerType | undefined;
  defaultDynamicFilters?: IDynamicFilterItem[];
  resolve(params: ResolveParams): Promise<any>;
  delete?: (ids: any[]) => Promise<any>;
  tabs?: ITabsContainerTab[] | undefined;
  sideMenuItems?: ISideMenuItem[] | undefined;
  permissions?: IRouteMetaPermissions | undefined;
  titleField?: string;
  containerListItems?: RouteMetaListItemInterface[] | undefined;
  fullPageScroll?: boolean;
}

export interface IRouteMetaResolveResults extends IRouteMeta {
  isRouteCanceled: boolean;
  guardResolveResults: Map<RouteRecordNormalized, ResolveResult[]>;
}

export interface IFormSavePromise {
  resolve: undefined | ((value: void | PromiseLike<void>) => void);
  reject: undefined | ((value: void | PromiseLike<void>) => void);
}

export class ResolveResult {
  routeName: string;
  initialDynamicFilters: IDynamicFilterItem[] | undefined;
  initialFiltersFromUserPreferences: IFilterItem[];
  pagination: Pagination;
  params: RouteParams;

  constructor(pagination: Pagination | undefined, pagedData: IPagedList<any>, resolveParams: ResolveParams) {
    this.pagination = {
      ...pagination,
      rowsNumber: pagedData.totalRecords,
      page: pagedData.pageNumber || pagination?.page || 1,
    };
    this.params = resolveParams.params;
    this.routeName = resolveParams.routeName;
    this.initialDynamicFilters = resolveParams.initialDynamicFilters;
    this.initialFiltersFromUserPreferences = resolveParams.initialFiltersFromUserPreferences;
  }
}

export interface ITabsContainerTab {
  to: string;
  label: string;
  icon?: string;
  iconHover?: string;
  tooltip?: string;
  useWritePermission?: boolean;
  badgeValue?: () => Ref<string>;
}

export class ResolveDrawerParams {
  idDrawer: AppEnums.DrawerIds;
  resolveParams: ResolveParams;
  resolveStoreAction: (params: ResolveParams) => Promise<any>;

  constructor(idDrawer: AppEnums.DrawerIds, storeAction: (params: ResolveParams) => Promise<any>) {
    this.idDrawer = idDrawer;
    this.resolveStoreAction = storeAction;
    this.resolveParams = new ResolveParams();
    this.resolveParams.containerType = AppCoreEnums.ContainerType.DrawerContainer;
  }
}

export interface RouteMetaListItemInterface {
  to: string;
  label: string;
  icon?: string;
  iconHover?: string;
  tooltip?: string;
  useWritePermission?: boolean;
}
